const componentsComboboxPersonSelectorComboboxEn = {
  searchPersonPlaceholder: 'Search person...',
};

export default componentsComboboxPersonSelectorComboboxEn;
